import { CE_MODAL_CLOSE } from "@js/actions/studio/modals.js";

export const CE_MODAL_UPLOAD_ATTACHMENT_OPEN =
  "CE_MODAL_UPLOAD_ATTACHMENT_OPEN";
export const ceModalUploadAttachmentOpen = () => ({
  type: CE_MODAL_UPLOAD_ATTACHMENT_OPEN,
});

export const CE_MODAL_UPLOAD_ATTACHMENT_OPEN_FILE_PICKER =
  "CE_MODAL_UPLOAD_ATTACHMENT_OPEN_FILE_PICKER";
export const ceModalUploadAttachmentOpenFilePicker = () => ({
  type: CE_MODAL_UPLOAD_ATTACHMENT_OPEN_FILE_PICKER,
});

export const CE_MODAL_UPLOAD_ATTACHMENT_CANCEL_FILE_PICKER =
  "CE_MODAL_UPLOAD_ATTACHMENT_CANCEL_FILE_PICKER";
export const ceModalUploadAttachmentCancelFilePicker = () => ({
  type: CE_MODAL_UPLOAD_ATTACHMENT_CANCEL_FILE_PICKER,
});

export const CE_MODAL_UPLOAD_ATTACHMENT_LOAD_FILE =
  "CE_MODAL_UPLOAD_ATTACHMENT_LOAD_FILE";
export const ceModalUploadAttachmentLoadFile = (
  fileName,
  fileContentsBase64,
  size,
) => ({
  type: CE_MODAL_UPLOAD_ATTACHMENT_LOAD_FILE,
  attachment_name: fileName,
  data_base64: fileContentsBase64,
  size: size,
});

export const CE_MODAL_UPLOAD_ATTACHMENT_SAVE =
  "CE_MODAL_UPLOAD_ATTACHMENT_SAVE ";
export const ceModalUploadAttachmentSave = () => ({
  type: CE_MODAL_UPLOAD_ATTACHMENT_SAVE,
});

export const ceModalUploadAttachmentCancel = () => ({
  type: CE_MODAL_CLOSE,
});
